import { Injectable } from '@angular/core';
import { Database, ref, set, update, push, get, remove, query, orderByChild, equalTo, startAt, endAt, limitToFirst, limitToLast, onValue } from '@angular/fire/database';
import { Auth } from '@angular/fire/auth';
import { Storage, uploadBytes, ref as storageRef } from '@angular/fire/storage';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    private auth: Auth,
    private db: Database,
    private storage: Storage
  ) {}

  /** 🔹 Update an existing node */
  firebaseUpdateData(node: string, value: any) {
    const nodeRef = ref(this.db, node);
    return update(nodeRef, value);
  }

  /** 🔹 Push new data (auto-generated key) */
  firebasePushData(node: string, value: any) {
    const listRef = ref(this.db, node);
    return push(listRef, value);
  }

  /** 🔹 Get realtime updates for a list */
  getFirebaseListTypeValues(node: string): Observable<any[]> {
    return new Observable((observer) => {
      const listRef = ref(this.db, node);
      onValue(listRef, (snapshot) => {
        const data = snapshot.val();
        const arr = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
        observer.next(arr);
      });
    });
  }

  /** 🔹 Get realtime updates with limit */
  getFirebaseListLimit(node: string, limit: number): Observable<any[]> {
    return new Observable((observer) => {
      const listRef = query(ref(this.db, node), limitToFirst(limit));
      onValue(listRef, (snapshot) => {
        const data = snapshot.val();
        const arr = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
        observer.next(arr);
      });
    });
  }

  /** 🔹 Get one object as observable */
  getFirebaseObjectTypeValues(node: string): Observable<any> {
    return new Observable((observer) => {
      const objRef = ref(this.db, node);
      onValue(objRef, (snapshot) => observer.next(snapshot.val()));
    });
  }

  /** 🔹 Delete a node */
  firebaseDeleteNode(node: string) {
    const nodeRef = ref(this.db, node);
    return remove(nodeRef);
  }

  /** 🔹 Set data (replace) */
  firebaseSetData(node: string, value: any) {
    const nodeRef = ref(this.db, node);
    return set(nodeRef, value);
  }

  /** 🔹 File Upload */
  uploadFile(filePath: string, file: File) {
    const fileRef = storageRef(this.storage, filePath);
    return uploadBytes(fileRef, file);
  }

  /** 🔹 Query: orderByChild + equalTo */
  getOrderByChild(path: string, key: string, value: any): Observable<any[]> {
    return new Observable((observer) => {
      const q = query(ref(this.db, path), orderByChild(key), equalTo(value));
      onValue(q, (snapshot) => {
        const data = snapshot.val();
        const arr = data ? Object.keys(data).map(k => ({ id: k, ...data[k] })) : [];
        observer.next(arr);
      });
    });
  }

  /** 🔹 Query: search range */
  searchBy(path: string, key: string, start: any, end: any): Observable<any[]> {
    return new Observable((observer) => {
      const q = query(ref(this.db, path), orderByChild(key), startAt(start), endAt(end));
      onValue(q, (snapshot) => {
        const data = snapshot.val();
        const arr = data ? Object.keys(data).map(k => ({ id: k, ...data[k] })) : [];
        observer.next(arr);
      });
    });
  }
}


